import { useEffect } from 'react'

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const useInitializeVisitTypes = (serviceTypes, setVisitTypes) => {
  useEffect(() => {
    if (serviceTypes.length) {
      const types = {}
      // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
      serviceTypes.forEach((service) => {
        // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
        service.VisitTypes.forEach((visit) => {
          if (visit.VisibilityType !== 'none') {
            // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
            types[visit.VisitTypeId] = {
              ...visit,
              ServiceTypeId: service.ServiceTypeId,
              ServiceVisitName: `${service.Name} (${visit.Name})`,
            }
          }
        })
      })
      setVisitTypes(types)
    }
  }, [serviceTypes, setVisitTypes])
}
